// extracted by mini-css-extract-plugin
module.exports = {"card":"NFatb","label":"NFt7","wrap":"NFav","link":"NFch","imageWrap":"NFo-","title":"NFal","btn":"NFa1","btnPrev":"NFak-","btnNext":"NFalb","btnHidden":"NFawx","advLabel":"NFkh"};